import {Formatter} from './units-formatter';

export class VelocityResolutionToMetersPerSecondFormatter extends Formatter {
  apply(seconds: number): string {
    seconds = seconds * 1000;
    return seconds.toFixed(this.numberDecimals);
  }
}
